import { render, staticRenderFns } from "./AfterSalesManage copy.vue?vue&type=template&id=4ae3a47a"
import script from "./AfterSalesManage copy.vue?vue&type=script&lang=js"
export * from "./AfterSalesManage copy.vue?vue&type=script&lang=js"
import style0 from "./AfterSalesManage copy.vue?vue&type=style&index=0&id=4ae3a47a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports